import { truckModelsApi } from "./truckModels.api";

export const { useGetTruckModelQuery, useLazyGetTruckModelsByBrandQuery, useGetTruckModelsQuery, useSaveTruckModelMutation, useDeleteTruckModelMutation } = truckModelsApi;
